module.exports = __webpack_public_path__ + "static/img/footer_icon_12_zh.957bf03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer_icon_12_zh.png
// module id = uSBq
// module chunks = 34